function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "196px",
    height: "150px",
    viewBox: "0 0 180 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,62.745098%,64.313725%)",
      fillopacity: 1
    },
    d: "M 172.265625 124.269531 C 171.457031 124.5625 170.605469 124.714844 169.746094 124.714844 C 166.839844 124.714844 164.242188 122.914062 163.21875 120.191406 C 151.507812 90.039062 122.484375 70.167969 90.136719 70.152344 C 57.789062 70.136719 28.746094 89.976562 17.003906 120.117188 C 16.351562 121.878906 15.011719 123.296875 13.292969 124.046875 C 11.585938 124.757812 9.664062 124.757812 7.957031 124.046875 C 4.472656 122.492188 2.742188 118.546875 3.953125 114.929688 C 17.777344 79.445312 51.957031 56.078125 90.035156 56.078125 C 128.117188 56.078125 162.296875 79.445312 176.121094 114.929688 C 177.488281 118.570312 175.804688 122.652344 172.265625 124.269531 Z M 172.265625 124.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,62.745098%,64.313725%)",
      fillopacity: 1
    },
    d: "M 90.183594 81.5625 C 71.652344 81.96875 56.933594 97.28125 57.265625 115.816406 C 56.933594 134.339844 71.664062 149.636719 90.183594 150 C 108.707031 149.636719 123.4375 134.339844 123.105469 115.816406 C 123.4375 97.28125 108.71875 81.96875 90.183594 81.5625 Z M 90.183594 135.910156 C 79.085938 135.910156 70.089844 126.914062 70.089844 115.816406 C 70.089844 104.71875 79.085938 95.722656 90.183594 95.722656 C 101.28125 95.722656 110.277344 104.71875 110.277344 115.816406 C 110.277344 126.914062 101.28125 135.910156 90.183594 135.910156 Z M 90.183594 135.910156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,62.745098%,64.313725%)",
      fillopacity: 1
    },
    d: "M 175.230469 49.679688 L 157.214844 66.066406 C 154.019531 68.910156 149.125 68.628906 146.277344 65.433594 C 143.433594 62.242188 143.714844 57.34375 146.90625 54.5 L 165.296875 38.039062 C 166.816406 36.664062 168.8125 35.945312 170.859375 36.035156 C 172.921875 36.121094 174.855469 37.058594 176.195312 38.628906 C 178.929688 41.964844 178.5 46.871094 175.230469 49.679688 Z M 175.230469 49.679688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,62.745098%,64.313725%)",
      fillopacity: 1
    },
    d: "M 33.609375 65.472656 C 32.292969 67.050781 30.378906 68.007812 28.328125 68.121094 C 26.273438 68.234375 24.269531 67.488281 22.785156 66.066406 L 4.695312 49.679688 C 1.574219 46.746094 1.3125 41.878906 4.101562 38.628906 C 5.476562 37.023438 7.472656 36.078125 9.585938 36.035156 C 11.65625 35.933594 13.679688 36.652344 15.222656 38.039062 L 33.019531 54.5 C 36.203125 57.367188 36.46875 62.273438 33.609375 65.472656 Z M 33.609375 65.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,62.745098%,64.313725%)",
      fillopacity: 1
    },
    d: "M 97.898438 7.785156 L 97.898438 32.402344 C 97.898438 36.660156 94.445312 40.113281 90.183594 40.113281 C 85.925781 40.113281 82.472656 36.660156 82.472656 32.402344 L 82.472656 7.785156 C 82.472656 3.527344 85.925781 0.0742188 90.183594 0.0742188 C 94.445312 0.0742188 97.898438 3.527344 97.898438 7.785156 Z M 97.898438 7.785156 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.c5b49a0bfed814811b20bb7061c9730a.svg";
export { ForwardRef as ReactComponent };